// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3sS5w","label":"Category_label__2-9ry","content":"Category_content__JjZZX","header":"Category_header__2mGys","location":"Category_location__JhsNz"};